import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";

export const useLocationAdmin = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentLocation, setCurrentLocation] = useState(null); // Store the location being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentLocation(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((location) => {
    setEditMode(true);
    setCurrentLocation(location);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentLocation,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
